import { createSelector } from "@reduxjs/toolkit";

const gameSelector = (state) => state.game;

export const btcChartSelector = createSelector(
    [gameSelector],
    (game) => game.btcChartData
  );